export default "__VITE_ASSET__DheWMyD4__"